$.fn.BrochuresForm_QuantityField = function() {
  let self = this
  self.quantity = undefined
  self.checkbox = self.find('input[type="checkbox"]')

  self.changed = function() {
    if ($(this).on('change')) {
      if ($(this).val() < 1) {
        self.checkbox.prop('checked', false).trigger('change')
      }
    }
  }

  self.checked = function() {
    if (self.checkbox.prop('checked')) {
      self.quantity.closest('.field').removeClass('disabled')
      self.quantity.prop('disabled', false)
      if (!parseFloat(self.quantity.val())) {
        self.quantity.val(1)
      }
      self.quantity.on('change', self.changed)
    } else {
      self.quantity.closest('.field').addClass('disabled')
      self.quantity.prop('disabled', true).val(0)
      self.quantity.off('change', self.changed)
    }
  }

  self.initialize = function() {
    self.next('.field-container').find('input[type="number"]').each(function() {
      self.quantity = $(this).Quantity()
      self.quantity.closest('.field').addClass('disabled')
      self.quantity.prop('disabled', true).val(0)
    })
    self.checkbox.on('change', self.checked)
  }

  return function() {
    self.initialize()
    return self
  }()
}

$.fn.BrochuresForm = function() {
  let self = this

  self.initialize_quantities = function() {
    /* Each checkbox + quantity field */
    $('.field-container--guide_touristique, .field-container--carte_velo, .field-container--carte_motoneige').each(function() {
      $(this).BrochuresForm_QuantityField()
    })
  }

  self.initialize_address = function() {
    const autocomplete = new google.maps.places.Autocomplete(self.find('input[name="adresse"]').get(0), {
      types: ['address'],
    })
    google.maps.event.addListener(autocomplete, 'place_changed', function(e) {
      let place = autocomplete.getPlace(),
      adresse = '', adresse_2 = '', ville = '', code_postal = '', pays = '', province = ''
      self.find('input[name="autocomplete_place"]').val(encodeURIComponent(JSON.stringify(place)))
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        switch (addressType) {
          case 'subpremise':
            adresse_2 += place.address_components[i]['long_name'];
            break;
          case 'street_number':
            adresse = place.address_components[i]['long_name'] + ' ' + adresse;
            break;
          case 'route':
            adresse += place.address_components[i]['long_name'];
            break;
          case 'locality':
            ville = place.address_components[i]['long_name'];
            break;
          case 'postal_code':
            code_postal = place.address_components[i]['long_name'];
            break;
          case 'country':
            pays = place.address_components[i]['long_name'];
            break;
          case 'administrative_area_level_1':
            province = place.address_components[i]['long_name'];
            break;
        }
      }
      if (adresse_2) adresse += ' ' + adresse_2;
      self.find('input[name="adresse"]').val(adresse).trigger('change')
      self.find('input[name="ville"]').val(ville).trigger('change')
      self.find('input[name="pays"]').val(pays).trigger('change')
      self.find('input[name="code_postal"]').val(code_postal).trigger('change')
      self.find('input[name="province"]').val(province).trigger('change')
    })
  }

  return function() {
    self.initialize_address()
    self.initialize_quantities()
    return self
  }()
}
